<i18n src="./resources/locales.json"></i18n>

<template>
  <div
    class="ecs-select-agent-extension white--text"
    :class="{ active: isWaitingForAgentTerminalEvent }"
    :dark="$vuetify.theme.dark"
    @click="openEndpointSelectionDialog"
  >
    <div class="label">{{ $t('label') }}</div>
    <div class="value-wrapper">
      <div v-if="isRegisteringSoftPhone" class="value progress">
        {{ $t('softPhone.registering') }}
      </div>
      <div v-else class="value">
        <v-icon
          v-show="isSoftPhoneReadyToUse || softPhoneRegistrationErrors"
          class="soft-phone-state-icon"
          small
          :color="isSoftPhoneReadyToUse ? '' : 'warning'"
        >
          {{ isSoftPhoneReadyToUse ? 'mdi-cellphone-link' : 'mdi-alert' }}
        </v-icon>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{ currentExtension }}
            </span>
          </template>
          <span>{{ tooltip }}</span>
        </v-tooltip>
      </div>

      <v-btn v-if="softPhoneRegistrationErrors" icon small class="retry-btn" @click.stop="registerSoftPhone">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </div>

    <v-progress-circular
      :class="{ show: isWaitingForAgentTerminalEvent || isRegisteringSoftPhone }"
      class="is-waiting-spinner"
      color="white"
      size="16"
      width="2"
      indeterminate
    />

    <EcsEndpointSelectionDialogContainer ref="endpointSelectionDialog" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EcsEndpointSelectionDialogContainer from '@/components/ecs-endpoint-selection-dialog/EcsEndpointSelectionDialogContainer.vue';
import EcsSoftPhoneMixin from '@/components/ecs-soft-phone/EcsSoftPhoneMixin';
export default {
  name: 'EcsSelectAgentExtension',

  components: { EcsEndpointSelectionDialogContainer },

  mixins: [EcsSoftPhoneMixin],

  data() {
    return {
      menuOpen: false
    };
  },

  computed: {
    ...mapGetters('AGENT', ['loggedInAgent']),

    ...mapGetters('SETTINGS', ['currentUserSettings']),

    ...mapGetters('EVENT_TIMING', ['isWaitingForAgentTerminal']),

    tooltip() {
      if (this.isSoftPhoneReadyToUse) {
        return this.$t('softPhone.ready');
      }

      if (this.softPhoneRegistrationErrors) {
        return this.$t('softPhone.error');
      }

      return this.currentExtension;
    },

    isWaitingForAgentTerminalEvent() {
      return this.isWaitingForAgentTerminal(this.loggedInAgent.id);
    },

    currentExtension() {
      return this.formatDestination(this.endpointCurrentDestination, this.endpointCurrentType);
    },

    endpointCurrentType() {
      return this.loggedInAgent.currentExtension ? this.loggedInAgent.currentExtension.terminalType : 'HPBXPhone';
    },

    endpointCurrentDestination() {
      return this.loggedInAgent.currentExtension
        ? this.loggedInAgent.currentExtension.terminalURI
        : this.loggedInAgent.hpbxExtension;
    }
  },

  methods: {
    ...mapActions('EVENT_TIMING', ['clearEventTimingConstraint']),

    formatDestination(value, format) {
      if (format === 'HPBXPhone' && value) {
        return `HPBX (${value.split('@')[0]})`;
      }

      return value || 'Loading...';
    },

    openEndpointSelectionDialog() {
      this.$refs.endpointSelectionDialog.open();
    }
  }
};
</script>

<style>
.v-tooltip {
  z-index: 9998;
}
</style>

<style scoped lang="scss">
.ecs-select-agent-extension {
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  height: 52px;
  position: relative;

  &.active,
  &:hover {
    background-color: #0004;
  }

  [dark] .soft-phone-state-icon {
    color: inherit;
  }

  .soft-phone-state-icon {
    margin: -2px 2px 0 0;
    color: #fff;

    &.warning {
      color: var(--v-warning-base);
    }

    &.ready {
      color: var(--v-success-base);
    }
  }

  .retry-btn {
    color: #fff;
    margin: -4px 0 0 8px;
  }

  .label {
    font-size: 12px;
    user-select: none;
    opacity: 0.5;
  }

  .value-wrapper {
    display: grid;
    grid-template-columns: auto 32px;
  }

  .value {
    opacity: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.progress {
      color: var(--v-warning-base);
    }
  }

  .is-waiting-spinner {
    position: absolute;
    right: 8px;
    top: 8px;
    opacity: 0;
    transition: all 0.1s ease-in-out;

    &.show {
      opacity: 1;
    }
  }
}
</style>
